/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useState } from "react";
import { useSpring, animated } from "@react-spring/web";
import { Container, Text } from "./styles";
import { useImagePath } from "hooks/useImagePath";
import { friendCenterAssets } from "assets/cdn";

interface BannerProps {
	text: string | undefined;
	text2: string | undefined;
}

export const InfoBanner: React.FC<BannerProps> = ({ text, text2 }) => {
	const { getImage } = useImagePath("cdn");

	return (
		<Container
			$backgroundImage={getImage(friendCenterAssets.friendShop.priceBadge)}
		>
			<Text>
				<span className="text">{text}</span>
				<span className="text2">{text2}</span>
			</Text>
		</Container>
	);
};
